import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

const FileService = {
  resource: API_RESOURCE.FILE,
  uploadFile: async ({ version, type, files }) => {
    try {
      const form = new FormData()
      form.append('type', type)
      form.append('version', version)

      for (let i = 0; i < files.length; i++) {
        form.append('files', files[i])
      }

      const response = await axios.post(`${API_RESOURCE.FILE}`, form)
      return response.data
    } catch (error) {
      console.error(`Error uploading file`, error)
      throw error
    }
  },

  downloadFile: async (id) => {
    const response = await axios.get(`${API_RESOURCE.FILE}/${id}/download`, {
      responseType: 'blob',
      // withCredentials: true,
    })

    return response
  },

  getFileDetailOnSharepoint: async (offerId) => {
    if (offerId) {
      const response = await axios.get(`offers/sharepoint/getTenderDocumentLink/${offerId}`)
      return response.data.data
    }
  },
}

export default FileService
